/*
  Name = fixtures.js
  Purpose = entry point for fixtures.php - show unplayed fixtues
*/
import $ from 'jquery';

$(function () {
  $('select[name="seasonId"]').on('change', function (e) {
    const seasonId = $('select[name="seasonId"]').val();
    makeFixturesDT(seasonId);
  });

  const seasonId = $('select[name="seasonId"]').val();
  makeFixturesDT(seasonId);
});

/**
 * create a Data Table showing the users in the system
 */
function makeFixturesDT (seasonId) {
  console.log('makeFixturesDT()');

  const table = '#fixtureTable';
  const $table = $(table);
  if ($table.length !== 1) {
    console.warn('Unable to locate table');
    return false;
  }

  if ($.fn.dataTable.isDataTable(table)) {
    const dt = $table.DataTable();
    dt.ajax.reload();
  } else {
    $table.DataTable({
      'ajax': {
        'data': function (d) {
          d.seasonId = $('select[name="seasonId"]').val();
        },
        'dataSrc': 'fixtures',
        'dataType': 'json',
        'error': function (xhr, textStatus, error) {
          switch (xhr.status) {
            case 400:
              // Bad request -- probably missing params
              $('#usersTable').find('td.dataTables_empty').html('<span>Error</span>');
              break;
            case 401:
              // 'Unauthorized' -- probably the session ended, reload should bounce us to the login page retaining the URL
              document.location.reload();
              break;
            case 403:
              // 'Forbidden' -- indicates the user did not have permission -- not admin?
              document.location.reload();
              break;
            case 404:
              // Not Found -- bad request URL
              $('#usersTable').find('td.dataTables_empty').html('<span>Error</span>');
              break;
            case 500:
              // server side crash
              $('#usersTable').find('td.dataTables_empty').html('<span>Error</span>');
              break;
            default:
                  // others
          }
          console.log('%o %o %o', xhr, textStatus, error);
        },
        'type': 'GET',
        'url': 'database/getFixtures.php'
      },
      'columns': [
        {
          'data': 'date',
          'responsivePriority': 1
        },
        { 'data': 'event', 'responsivePriority': 1 },
        { 'data': 'division', 'responsivePriority': 4 },
        { 'data': 'homeTeam', 'responsivePriority': 3 },
        { 'data': 'awayTeam', 'responsivePriority': 3 }
      ],
      'language': { 'emptyTable': 'There are no further fixtures for this season' },
      'order': [[0, 'asc']],
      'responsive': true,
      'stateSave': true
    });
  }
};
